
import AccountsApi from '@/services/identity/AccountsApi';
import { showApiErrorSnackbar, createErrorMessage, showSnackbar } from './snackBarUtil';
import { authenticationStore } from '@/store/pinia/AuthenticationStore';
import { Account, UserFields } from '@/store/types/identity';
import { DataTableHeader } from '@/components/types/DataTable';
import { i18n } from '@/plugins/i18n';
import { Device } from '@/store/types/inventory/Device';
import { deviceTableConfigurableColumns } from '@/models/inventory/deviceTableConfig';
import { onPremises } from '@/shared/utils';

export const updateUserFieldsForDevicesTable = async (deviceTableHeaders: DataTableHeader<Device>[]) => {
  const authStore = authenticationStore();
  try {
    const response = await AccountsApi.getById(authStore.loggedInAccount.uuid);
    const account = response.data as Account;
    account.userFields = {
      devices: deviceTableHeaders
    };
    await AccountsApi.update(account);
    await authStore.refreshLoggedInAccountInformation();
    showSnackbar(i18n.t('administration.tableSettingsSaved').toString());
  } catch (error) {
    showApiErrorSnackbar(createErrorMessage(error), error);
  }
};

export const getDefaultUserFields = (): UserFields => {
  let defaultUserFields: UserFields;
  if (onPremises()) {
    defaultUserFields = {
      devices: deviceTableConfigurableColumns.filter(
        (header) =>
          header.default === true && header.excludedInOnPrem !== onPremises()
      )
    };
  } else {
    defaultUserFields = {
      devices: deviceTableConfigurableColumns.filter(
        (header) =>
          header.default === true && (header.excludedInCloud ?? false) === onPremises()
      )
    };
  }
  return defaultUserFields;
};

export const getDefaultDeviceTableUserFields = (): DataTableHeader<Device>[] => getDefaultUserFields().devices;
